import { Controller, useFormContext } from 'react-hook-form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export function QuestionTypeSelector({
  questionId,
  value,
  onChange,
}: {
  questionId: string;
  value: PolicyFormQuestion['type'];
  onChange: (id: string, updates: Partial<PolicyFormQuestion>) => void;
}) {
  const { control } = useFormContext();

  const typeGroups: Record<string, string[]> = {
    textGroup: ['text', 'number', 'textarea', 'date'],
    selectGroup: ['select', 'radio'],
    other: ['multiselect', 'table', 'textselect'],
  };

  return (
    <Controller
      control={control}
      name={`questions.${questionId}.type`}
      render={({ field }) => (
        <Select
          value={(field.value ?? value) as PolicyFormQuestion['type']}
          onValueChange={val => {
            field.onChange(val);
            onChange(questionId, { type: val as PolicyFormQuestion['type'] });
          }}
        >
          <SelectTrigger className="w-[130px] text-sm text-black">
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            {(() => {
              const currentType = (field.value ?? value) as PolicyFormQuestion['type'];
              const allowedTypes = typeGroups.textGroup.includes(currentType)
                ? typeGroups.textGroup
                : typeGroups.selectGroup.includes(currentType)
                  ? typeGroups.selectGroup
                  : typeGroups.other.includes(currentType)
                    ? typeGroups.other
                    : [...typeGroups.textGroup, ...typeGroups.selectGroup, ...typeGroups.other];
              return allowedTypes;
            })().map(type => (
              <SelectItem
                key={type}
                value={type}
              >
                {type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    />
  );
}